import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between relative w-full" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 1,
  class: "italic mt-15"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["href"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "flex flex-col mb-20" }
const _hoisted_9 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_c_icon = _resolveComponent("c-icon")!
  const _component_DisclosureButton = _resolveComponent("DisclosureButton")!
  const _component_RouterLinkConditional = _resolveComponent("RouterLinkConditional")!
  const _component_DisclosurePanel = _resolveComponent("DisclosurePanel")!
  const _component_Disclosure = _resolveComponent("Disclosure")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reversedFooterColumns, (footerColumn, idx) => {
    return (_openBlock(), _createBlock(_component_Disclosure, {
      key: footerColumn.headerLink.url+idx
    }, {
      default: _withCtx(({ open }) => [
        _createVNode(_component_DisclosureButton, { class: "flex justify-between items-center w-full text-left pt-15" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("h3", null, _toDisplayString(footerColumn.headerLink.text), 1),
              _createVNode(_component_c_icon, {
                name: "icon-minus",
                "aria-hidden": "true",
                class: "absolute right-0 top-0 h-12 lg:h-20"
              }),
              _createVNode(_component_c_icon, {
                name: "icon-minus",
                "aria-hidden": "true",
                class: _normalizeClass(["absolute right-0 top-0 transition-all duration-300 h-12 lg:h-20", {'rotate-0 opacity-0': open, 'rotate-90': !open}])
              }, null, 8, ["class"])
            ])
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_DisclosurePanel, { class: "o-text-caption magic-line-on-hover-on-child-links mt-6 pr-30 lg:pr-120 xl:pr-50" }, {
          default: _withCtx(() => [
            (footerColumn.freeText)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "italic mt-10",
                  innerHTML: footerColumn.freeText
                }, null, 8, _hoisted_2))
              : _createCommentVNode("", true),
            (idx === 0 && (_ctx.footer.phone || _ctx.footer.email))
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_ctx.footer.phone)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                        _createTextVNode(_toDisplayString(_ctx.$dictionary.get('b2c/footer/phone')) + ": ", 1),
                        _createElementVNode("a", {
                          href: 'phone:'+_ctx.footer.phone
                        }, _toDisplayString(_ctx.footer.phone), 9, _hoisted_5)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.footer.email)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                        _createTextVNode(_toDisplayString(_ctx.$dictionary.get('b2c/footer/email')) + ": ", 1),
                        _createElementVNode("a", {
                          href: 'mailto:'+_ctx.footer.email
                        }, _toDisplayString(_ctx.footer.email), 9, _hoisted_7)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("ul", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(footerColumn.links, (columnLink, subIdx) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: columnLink.url+subIdx,
                  class: "mt-10"
                }, [
                  _createVNode(_component_RouterLinkConditional, {
                    to: columnLink.url,
                    target: columnLink.target,
                    "spa-enabled": columnLink.spaLink,
                    title: columnLink.title || columnLink.text,
                    class: "c-link c-link--dark c-magic-line"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(columnLink.text), 1)
                    ]),
                    _: 2
                  }, 1032, ["to", "target", "spa-enabled", "title"])
                ]))
              }), 128))
            ]),
            (idx === 0)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 2,
                  class: "mt-x1 whitespace-pre",
                  innerHTML: _ctx.footer.legalCodes
                }, null, 8, _hoisted_9))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 2
    }, 1024))
  }), 128))
}